import React from 'react';
import PropTypes from 'prop-types';
import { Button, Container, Grid, Typography } from '@material-ui/core';

import IndietroButton from '../../../components/IndietroButton';
import SpinnerComponent from '../../../components/SpinnerComponent';
import SelezioneGruppo from '../components/SelezioneGruppo';
import SelezioneEsercizio from './SelezioneEsercizio';

import { isAdminUser, isConsulenteUser } from '../../../utils/storage';
import {
  registerResponsabileSicurezza,
  registerResponsabileSicurezzaAssociatedToEsercizio,
} from '../../../utils/api/responsabili_sicurezza_api';
import { getGruppi } from '../../../utils/api/gruppi_api';
import { getEserciziCommerciali } from '../../../utils/api/esercizi_commerciali_api';

import validator from 'validator';
import { AUTH_OPTIONS, AUTH_TYPES } from '../../../auth/auth.options';
import UserCredentialsSection from './UserCredentialsSection';
import { reportApiError } from '../../../utils/reportApiError';

const styles = {
  mainContainer: {
    paddingLeft: '4px',
    paddingRight: '4px',
    maxWidth: '840px',
    minHeight: '500px',
  },
  sectionContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
};

export default class FormRegistraResponsabile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      record: {
        email: '',
        password: '',
        confirmPassword: '',
        nome: null,
        cognome: null,
        telefono: null,
        terminiUsoAccettati: false,
        privacyPolicyAccettata: false,
        gruppoId: props.gruppoId ?? null,
        esercizioId: '',
        // authType: AUTH_TYPES.LOCAL,
        passwordEnabled: true,
        oauthEnabled: false,
      },
      validationErrors: {
        email: '',
        password: '',
        confirmPassword: '',
        esercizioId: '',
      },
      gruppi: [],
      esercizi: [],
      showPassword1: false,
      showPassword2: false,
      loading: false,
      disableForm: false,
      saveButtonEnabled: false,
    };
  }

  componentDidMount() {
    if (isConsulenteUser()) {
      this.fetchEserciziConsulente();
    } else if (isAdminUser()) {
      this.fetchGruppi();
    }
  }

  fetchGruppi = () => {
    this.setState({ loading: true });
    getGruppi(null, null, 0, 1000, 'nome')
      .then((result) => {
        let gruppoId = this.state.record.gruppoId;
        if (gruppoId === null) {
          for (let i = 0; i < result.length; i++) {
            if (result[i].nome === 'BSFOOD') {
              gruppoId = result[i].id;
              break;
            }
          }
        }

        this.setState((prev) => ({
          loading: false,
          gruppi: result,
          record: { ...prev.record, gruppoId },
        }));
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  fetchEserciziConsulente = () => {
    this.setState({ loading: true });
    getEserciziCommerciali(
      this.props.gruppoId,
      this.props.consulenteId,
      null,
      null,
      0,
      1000,
      'id',
    )
      .then((result) => {
        this.setState({
          esercizi: result,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  handleClickShowPassword1 = () => {
    this.setState((prev) => ({ showPassword1: !prev.showPassword1 }));
  };

  handleClickShowPassword2 = () => {
    this.setState((prev) => ({ showPassword2: !prev.showPassword2 }));
  };

  validateForm = () => {
    const isConsulente = isConsulenteUser();
    const data = this.state.record;
    const validationErrors = { ...this.state.validationErrors };

    Object.keys(data).forEach((key) => {
      if (
        !data.passwordEnabled &&
        (key === 'password' || key === 'confirmPassword')
      ) {
        return;
      }

      // esercizioId serve solo in modalità consulente
      if (!isConsulente && key === 'esercizioId') return;

      this.validateField(key, data[key], validationErrors);
    });

    this.setState({ validationErrors });
    return Object.values(validationErrors).every((val) => val.length === 0);
  };

  validateField = (key, value, validationErrors) => {
    const insertedPsw = this.state.record.password;

    switch (key) {
      case 'email':
        if (value.length === 0) {
          validationErrors.email = "Inserire l'indirizzo email";
        } else {
          validationErrors.email = validator.isEmail(value)
            ? ''
            : "L'indirizzo email inserito non è valido";
        }
        break;

      case 'password':
        validationErrors.password =
          value.length >= 8
            ? ''
            : 'Inserire una password di almeno 8 caratteri';
        break;

      case 'confirmPassword':
        if (value.length === 0) {
          validationErrors.confirmPassword = 'Ripetere la password';
        } else {
          validationErrors.confirmPassword =
            value === insertedPsw ? '' : 'Le due password non corrispondono';
        }
        break;

      case 'esercizioId':
        validationErrors.esercizioId =
          value.length === 0 ? 'Selezionare un esercizio' : '';
        break;

      default:
        break;
    }
  };

  handleFormChange = (fieldName, value) => {
    this.props.onFormModified();

    this.setState((prev) => {
      const record = { ...prev.record, [fieldName]: value };
      const validationErrors = { ...prev.validationErrors };

      if (
        fieldName === 'email' ||
        fieldName === 'password' ||
        fieldName === 'confirmPassword' ||
        fieldName === 'esercizioId'
      ) {
        validationErrors[fieldName] = '';
      }

      return {
        record,
        validationErrors,
        saveButtonEnabled: true,
      };
    });
  };

  handleSelectedGruppo = (gruppoId) => {
    this.handleFormChange('gruppoId', gruppoId);
  };

  handleSelectedEsercizio = (esercizioId) => {
    this.handleFormChange('esercizioId', esercizioId);
  };

  handleAuthTypeChange = (selected) => {
    const isLocal = selected === AUTH_TYPES.LOCAL;

    this.props.onFormModified();

    this.setState((prevState) => ({
      record: {
        ...prevState.record,
        passwordEnabled: isLocal,
        oauthEnabled: !isLocal,
        ...(isLocal ? {} : { password: '', confirmPassword: '' }),
      },
      validationErrors: {
        ...prevState.validationErrors,
        email: '',
        password: '',
        confirmPassword: '',
        ...(isConsulenteUser() ? { esercizioId: '' } : {}),
      },
    }));
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const isConsulente = isConsulenteUser();
    const isFormValid = this.validateForm();
    if (!isFormValid) return;

    this.setState({ loading: true });

    const apiCall = isConsulente
      ? registerResponsabileSicurezzaAssociatedToEsercizio(this.state.record)
      : registerResponsabileSicurezza(this.state.record);

    apiCall
      .then(() => {
        this.setState({
          loading: false,
          saveButtonEnabled: false,
          disableForm: true,
        });
        this.props.onFormSubmitted();
      })
      .catch((error) => {
        const enableSave = error.status === 409 ? false : true;
        this.setState({
          loading: false,
          saveButtonEnabled: enableSave,
        });
        reportApiError(error);
      });
  };

  renderExtraSection = () => {
    const isConsulente = isConsulenteUser();
    const isAdmin = isAdminUser();

    if (isConsulente) {
      return (
        <Container style={styles.sectionContainer}>
          <Typography variant="h6">Esercizio commerciale associato</Typography>

          <SelezioneEsercizio
            hasError={this.state.validationErrors.esercizioId.length > 0}
            esercizioId={this.state.record.esercizioId}
            esercizi={this.state.esercizi}
            disabled={this.state.disableForm}
            description="Selezionare l'esercizio commerciale al quale associare il nuovo responsabile sicurezza."
            onEsercizioSelected={this.handleSelectedEsercizio}
          />
        </Container>
      );
    }

    if (isAdmin)
      return (
        <Container style={styles.sectionContainer}>
          <Typography variant="h6">Dati gruppo</Typography>

          <SelezioneGruppo
            gruppoId={this.state.record.gruppoId}
            gruppi={this.state.gruppi}
            disabled={this.state.disableForm}
            description="Scegliere il gruppo di appartenenza del nuovo responsabile sicurezza."
            onGruppoSelected={this.handleSelectedGruppo}
            onGruppoAdded={this.fetchGruppi}
          />
        </Container>
      );

    return null;
  };

  render() {
    const disabledSubmitbutton =
      this.state.loading || !this.state.saveButtonEnabled;

    return (
      <Container id="form_container" style={styles.mainContainer}>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container justify="center" alignItems="center">
              <Grid item xs={12} style={styles.sectionContainer}>
                <Typography
                  variant="h5"
                  style={{ paddingTop: '6px', paddingBottom: '6px' }}
                >
                  Dati utente
                </Typography>

                <UserCredentialsSection
                  authOptions={AUTH_OPTIONS}
                  record={this.state.record}
                  validationErrors={this.state.validationErrors}
                  disableForm={this.state.disableForm}
                  showPassword1={this.state.showPassword1}
                  showPassword2={this.state.showPassword2}
                  onToggleShowPassword1={this.handleClickShowPassword1}
                  onToggleShowPassword2={this.handleClickShowPassword2}
                  onFieldChange={this.handleFormChange}
                  onAuthTypeChange={this.handleAuthTypeChange}
                />
              </Grid>
            </Grid>

            {this.renderExtraSection()}

            <Grid
              container
              justify="center"
              style={{ paddingTop: '10px', paddingBottom: '20px' }}
            >
              <Grid item xs={12} style={{ textAlign: 'right' }}>
                <IndietroButton isDisabled={this.state.loading} />
                <Button
                  type="button"
                  onClick={this.handleSubmit}
                  variant="contained"
                  size="medium"
                  disabled={disabledSubmitbutton}
                  style={{
                    color: disabledSubmitbutton
                      ? this.props.theme.palette.text.disabled
                      : this.props.theme.palette.text.main,
                    margin: '10px',
                    backgroundColor: disabledSubmitbutton
                      ? this.props.theme.palette.disabled.main
                      : this.props.theme.palette.primary.main,
                  }}
                >
                  Registra
                </Button>
              </Grid>
            </Grid>
          </form>
        )}
      </Container>
    );
  }
}

FormRegistraResponsabile.propTypes = {
  theme: PropTypes.object.isRequired,
  gruppoId: PropTypes.number,
  onFormModified: PropTypes.func.isRequired,
  onFormSubmitted: PropTypes.func.isRequired,

  // solo consulente
  consulenteId: PropTypes.number,
};

FormRegistraResponsabile.defaultProps = {
  gruppoId: null,
  consulenteId: null,
};
